import { graphql } from '@apollo/react-hoc';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import get from 'lodash/get';

export const query = gql`
  query withUserInfo {
    userInfo {
      id
      userId
      country
      currency
      locale
      isLoggedIn
      username
      avatar
      showMatureContent
      federatedId
      experiments {
        experiment
        group
      }
      enrolments {
        experiment
        group
      }
    }
  }
`;

const withUserInfo = Component =>
  graphql(query, {
    props: ({ data: { loading, userInfo }, ownProps }) => {
      return {
        ...ownProps,
        loading: ownProps.loading || loading,
        userInfoLoading: loading,
        userInfo: userInfo || {}
      };
    }
  })(Component);

withUserInfo.displayName = 'withUserInfo';

export const useUserInfo = () => {
  const { data, loading } = useQuery(query);
  const userInfo = get(data, 'userInfo') || {};

  return {
    userInfo,
    userInfoLoading: loading
  };
};

export const userInfoShape = {
  id: PropTypes.string,
  userId: PropTypes.string,
  country: PropTypes.string,
  currency: PropTypes.string,
  locale: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  username: PropTypes.string,
  avatar: PropTypes.string,
  showMatureContent: PropTypes.bool,
  federatedId: PropTypes.string,
  experiments: PropTypes.arrayOf(
    PropTypes.shape({
      experiment: PropTypes.string,
      group: PropTypes.string
    })
  ),
  enrolments: PropTypes.arrayOf(
    PropTypes.shape({
      experiment: PropTypes.string,
      group: PropTypes.string
    })
  )
};

export default withUserInfo;
